module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/57e8961a64163e11b723414129e75693.png";